import React, { ReactNode } from 'react';

import { logCritical } from '@savgroup-front-common/configuration/src/appInsights/AppInsights';

import { buildPageTitle } from '../../helpers';

import ErrorBoundyTemplate from './ErrorBoundyTemplate';
import messages from './messages';

class ComponentErrorBoundary extends React.Component<
  { home?: string; children: ReactNode },
  { hasError: boolean; errorMessage?: string }
> {
  constructor(props: { home?: string; children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: any, errorInfo: any) {
    const errorMessage = error?.message;

    this.setState({ hasError: true, errorMessage });

    logCritical(error, { errorInfo });

    document.title = buildPageTitle([messages.title]);
  }

  render() {
    const { children, home } = this.props;
    const { hasError, errorMessage } = this.state;

    if (hasError) {
      return <ErrorBoundyTemplate home={home} errorMessage={errorMessage} />;
    }

    return children;
  }
}

export default ComponentErrorBoundary;
